import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OverallPerformance, LOBPerformance } from '@/types/dashboard';
import { 
  ChannelPerformanceBreakdownResponse,
  ProductStatusResponse,
  ChannelStatusResponse,
  SubchannelStatusResponse,
  ProductConversionResponse,
  ChannelConversionResponse,
  SubchannelConversionResponse,
  ProductChannelResponse,
  ChannelProductResponse
} from '@/services/api';

// Action Types
export const FETCH_CHANNEL_PERFORMANCE_BREAKDOWN_START = 'dashboard/fetchChannelPerformanceBreakdownStart';
export const FETCH_CHANNEL_PERFORMANCE_BREAKDOWN_SUCCESS = 'dashboard/fetchChannelPerformanceBreakdownSuccess';
export const FETCH_CHANNEL_PERFORMANCE_BREAKDOWN_FAILURE = 'dashboard/fetchChannelPerformanceBreakdownFailure';
export const FETCH_SUBCHANNEL_PERFORMANCE_BREAKDOWN_START = 'dashboard/FETCH_SUBCHANNEL_PERFORMANCE_BREAKDOWN_START';
export const FETCH_SUBCHANNEL_PERFORMANCE_BREAKDOWN_SUCCESS = 'dashboard/FETCH_SUBCHANNEL_PERFORMANCE_BREAKDOWN_SUCCESS';
export const FETCH_SUBCHANNEL_PERFORMANCE_BREAKDOWN_FAILURE = 'dashboard/FETCH_SUBCHANNEL_PERFORMANCE_BREAKDOWN_FAILURE';
export const FETCH_PRODUCT_PERFORMANCE_BREAKDOWN_START = 'dashboard/FETCH_PRODUCT_PERFORMANCE_BREAKDOWN_START';
export const FETCH_PRODUCT_PERFORMANCE_BREAKDOWN_SUCCESS = 'dashboard/FETCH_PRODUCT_PERFORMANCE_BREAKDOWN_SUCCESS';
export const FETCH_PRODUCT_PERFORMANCE_BREAKDOWN_FAILURE = 'dashboard/FETCH_PRODUCT_PERFORMANCE_BREAKDOWN_FAILURE';
export const FETCH_PRODUCT_CHANNEL_DISTRIBUTION_START = 'dashboard/FETCH_PRODUCT_CHANNEL_DISTRIBUTION_START';
export const FETCH_PRODUCT_CHANNEL_DISTRIBUTION_SUCCESS = 'dashboard/FETCH_PRODUCT_CHANNEL_DISTRIBUTION_SUCCESS';
export const FETCH_PRODUCT_CHANNEL_DISTRIBUTION_FAILURE = 'dashboard/FETCH_PRODUCT_CHANNEL_DISTRIBUTION_FAILURE';
export const FETCH_CHANNEL_PRODUCT_DISTRIBUTION_START = 'dashboard/FETCH_CHANNEL_PRODUCT_DISTRIBUTION_START';
export const FETCH_CHANNEL_PRODUCT_DISTRIBUTION_SUCCESS = 'dashboard/FETCH_CHANNEL_PRODUCT_DISTRIBUTION_SUCCESS';
export const FETCH_CHANNEL_PRODUCT_DISTRIBUTION_FAILURE = 'dashboard/FETCH_CHANNEL_PRODUCT_DISTRIBUTION_FAILURE';
export const FETCH_PRODUCT_STATUS_DISTRIBUTION_START = 'dashboard/FETCH_PRODUCT_STATUS_DISTRIBUTION_START';
export const FETCH_PRODUCT_STATUS_DISTRIBUTION_SUCCESS = 'dashboard/FETCH_PRODUCT_STATUS_DISTRIBUTION_SUCCESS';
export const FETCH_PRODUCT_STATUS_DISTRIBUTION_FAILURE = 'dashboard/FETCH_PRODUCT_STATUS_DISTRIBUTION_FAILURE';
export const FETCH_STATUS_PRODUCT_DISTRIBUTION_START = 'dashboard/FETCH_STATUS_PRODUCT_DISTRIBUTION_START';
export const FETCH_STATUS_PRODUCT_DISTRIBUTION_SUCCESS = 'dashboard/FETCH_STATUS_PRODUCT_DISTRIBUTION_SUCCESS';
export const FETCH_STATUS_PRODUCT_DISTRIBUTION_FAILURE = 'dashboard/FETCH_STATUS_PRODUCT_DISTRIBUTION_FAILURE';
export const FETCH_CHANNEL_STATUS_DISTRIBUTION_START = 'dashboard/FETCH_CHANNEL_STATUS_DISTRIBUTION_START';
export const FETCH_CHANNEL_STATUS_DISTRIBUTION_SUCCESS = 'dashboard/FETCH_CHANNEL_STATUS_DISTRIBUTION_SUCCESS';
export const FETCH_CHANNEL_STATUS_DISTRIBUTION_FAILURE = 'dashboard/FETCH_CHANNEL_STATUS_DISTRIBUTION_FAILURE';
export const FETCH_STATUS_CHANNEL_DISTRIBUTION_FAILURE = 'dashboard/FETCH_STATUS_CHANNEL_DISTRIBUTION_FAILURE';
export const FETCH_SUBCHANNEL_STATUS_DISTRIBUTION_START = 'dashboard/FETCH_SUBCHANNEL_STATUS_DISTRIBUTION_START';
export const FETCH_SUBCHANNEL_STATUS_DISTRIBUTION_SUCCESS = 'dashboard/FETCH_SUBCHANNEL_STATUS_DISTRIBUTION_SUCCESS';
export const FETCH_SUBCHANNEL_STATUS_DISTRIBUTION_FAILURE = 'dashboard/FETCH_SUBCHANNEL_STATUS_DISTRIBUTION_FAILURE';
export const FETCH_STATUS_SUBCHANNEL_DISTRIBUTION_START = 'dashboard/FETCH_STATUS_SUBCHANNEL_DISTRIBUTION_START';
export const FETCH_STATUS_SUBCHANNEL_DISTRIBUTION_SUCCESS = 'dashboard/FETCH_STATUS_SUBCHANNEL_DISTRIBUTION_SUCCESS';
export const FETCH_STATUS_SUBCHANNEL_DISTRIBUTION_FAILURE = 'dashboard/FETCH_STATUS_SUBCHANNEL_DISTRIBUTION_FAILURE';
export const FETCH_PRODUCT_CONVERSION_RATE_START = 'dashboard/FETCH_PRODUCT_CONVERSION_RATE_START';
export const FETCH_PRODUCT_CONVERSION_RATE_SUCCESS = 'dashboard/FETCH_PRODUCT_CONVERSION_RATE_SUCCESS';
export const FETCH_PRODUCT_CONVERSION_RATE_FAILURE = 'dashboard/FETCH_PRODUCT_CONVERSION_RATE_FAILURE';
export const FETCH_CHANNEL_CONVERSION_RATE_START = 'dashboard/FETCH_CHANNEL_CONVERSION_RATE_START';
export const FETCH_CHANNEL_CONVERSION_RATE_SUCCESS = 'dashboard/FETCH_CHANNEL_CONVERSION_RATE_SUCCESS';
export const FETCH_CHANNEL_CONVERSION_RATE_FAILURE = 'dashboard/FETCH_CHANNEL_CONVERSION_RATE_FAILURE';
export const FETCH_SUBCHANNEL_CONVERSION_RATE_START = 'dashboard/FETCH_SUBCHANNEL_CONVERSION_RATE_START';
export const FETCH_SUBCHANNEL_CONVERSION_RATE_SUCCESS = 'dashboard/FETCH_SUBCHANNEL_CONVERSION_RATE_SUCCESS';
export const FETCH_SUBCHANNEL_CONVERSION_RATE_FAILURE = 'dashboard/FETCH_SUBCHANNEL_CONVERSION_RATE_FAILURE';

// Action Creators
export const fetchChannelPerformanceBreakdownStart = (filters?: any) => ({ 
  type: FETCH_CHANNEL_PERFORMANCE_BREAKDOWN_START, 
  payload: filters 
});

export const fetchChannelPerformanceBreakdownSuccess = (data: ChannelPerformanceBreakdownResponse) => ({ 
  type: FETCH_CHANNEL_PERFORMANCE_BREAKDOWN_SUCCESS, 
  payload: data 
});

export const fetchChannelPerformanceBreakdownFailure = (error: string) => ({ 
  type: FETCH_CHANNEL_PERFORMANCE_BREAKDOWN_FAILURE, 
  payload: error 
});

export const fetchSubchannelPerformanceBreakdownStart = (filters?: any) => ({
  type: FETCH_SUBCHANNEL_PERFORMANCE_BREAKDOWN_START,
  payload: filters
});

export const fetchSubchannelPerformanceBreakdownSuccess = (data: any) => ({
  type: FETCH_SUBCHANNEL_PERFORMANCE_BREAKDOWN_SUCCESS,
  payload: data
});

export const fetchSubchannelPerformanceBreakdownFailure = (error: string) => ({
  type: FETCH_SUBCHANNEL_PERFORMANCE_BREAKDOWN_FAILURE,
  payload: error
});

export const fetchProductPerformanceBreakdownStart = (filters?: any) => ({
  type: FETCH_PRODUCT_PERFORMANCE_BREAKDOWN_START,
  payload: filters
});

export const fetchProductPerformanceBreakdownSuccess = (data: any) => ({
  type: FETCH_PRODUCT_PERFORMANCE_BREAKDOWN_SUCCESS,
  payload: data
});

export const fetchProductPerformanceBreakdownFailure = (error: string) => ({
  type: FETCH_PRODUCT_PERFORMANCE_BREAKDOWN_FAILURE,
  payload: error
});

// New action creators for distribution data
export const fetchProductChannelDistributionStart = () => ({
  type: FETCH_PRODUCT_CHANNEL_DISTRIBUTION_START
});
export const fetchProductChannelDistributionSuccess = (data: ProductChannelResponse) => ({
  type: FETCH_PRODUCT_CHANNEL_DISTRIBUTION_SUCCESS,
  payload: data
});
export const fetchProductChannelDistributionFailure = (error: string) => ({
  type: FETCH_PRODUCT_CHANNEL_DISTRIBUTION_FAILURE,
  payload: error
});
export const fetchChannelProductDistributionStart = () => ({
  type: FETCH_CHANNEL_PRODUCT_DISTRIBUTION_START
});
export const fetchChannelProductDistributionSuccess = (data: ChannelProductResponse) => {
  return {
    type: FETCH_CHANNEL_PRODUCT_DISTRIBUTION_SUCCESS,
    payload: data
  };
};
export const fetchChannelProductDistributionFailure = (error: string) => ({
  type: FETCH_CHANNEL_PRODUCT_DISTRIBUTION_FAILURE,
  payload: error
});

// New action creators for product-status and status-product distribution
export const fetchProductStatusDistributionStart = () => ({
  type: FETCH_PRODUCT_STATUS_DISTRIBUTION_START
});
export const fetchProductStatusDistributionSuccess = (data: ProductStatusResponse) => ({
  type: FETCH_PRODUCT_STATUS_DISTRIBUTION_SUCCESS,
  payload: data
});
export const fetchProductStatusDistributionFailure = (error: string) => ({
  type: FETCH_PRODUCT_STATUS_DISTRIBUTION_FAILURE,
  payload: error
});
export const fetchStatusProductDistributionStart = () => ({
  type: FETCH_STATUS_PRODUCT_DISTRIBUTION_START
});
export const fetchStatusProductDistributionSuccess = (data: ProductStatusResponse) => ({
  type: FETCH_STATUS_PRODUCT_DISTRIBUTION_SUCCESS,
  payload: data
});
export const fetchStatusProductDistributionFailure = (error: string) => ({
  type: FETCH_STATUS_PRODUCT_DISTRIBUTION_FAILURE,
  payload: error
});

// Add action creators for channel-status distribution
export const fetchChannelStatusDistributionStart = () => ({
  type: FETCH_CHANNEL_STATUS_DISTRIBUTION_START
});
export const fetchChannelStatusDistributionSuccess = (data: ChannelStatusResponse) => ({
  type: FETCH_CHANNEL_STATUS_DISTRIBUTION_SUCCESS,
  payload: data
});
export const fetchChannelStatusDistributionFailure = (error: string) => ({
  type: FETCH_CHANNEL_STATUS_DISTRIBUTION_FAILURE,
  payload: error
});

// Add action creators for subchannel-status distribution
export const fetchSubchannelStatusDistributionStart = () => ({
  type: FETCH_SUBCHANNEL_STATUS_DISTRIBUTION_START
});
export const fetchSubchannelStatusDistributionSuccess = (data: SubchannelStatusResponse) => ({
  type: FETCH_SUBCHANNEL_STATUS_DISTRIBUTION_SUCCESS,
  payload: data
});
export const fetchSubchannelStatusDistributionFailure = (error: string) => ({
  type: FETCH_SUBCHANNEL_STATUS_DISTRIBUTION_FAILURE,
  payload: error
});

// Add action creators for conversion rate data
export const fetchProductConversionRateStart = () => ({
  type: FETCH_PRODUCT_CONVERSION_RATE_START
});
export const fetchProductConversionRateSuccess = (data: ProductConversionResponse) => ({
  type: FETCH_PRODUCT_CONVERSION_RATE_SUCCESS,
  payload: data
});
export const fetchProductConversionRateFailure = (error: string) => ({
  type: FETCH_PRODUCT_CONVERSION_RATE_FAILURE,
  payload: error
});
export const fetchChannelConversionRateStart = () => ({
  type: FETCH_CHANNEL_CONVERSION_RATE_START
});
export const fetchChannelConversionRateSuccess = (data: ChannelConversionResponse) => ({
  type: FETCH_CHANNEL_CONVERSION_RATE_SUCCESS,
  payload: data
});
export const fetchChannelConversionRateFailure = (error: string) => ({
  type: FETCH_CHANNEL_CONVERSION_RATE_FAILURE,
  payload: error
});
export const fetchSubchannelConversionRateStart = () => ({
  type: FETCH_SUBCHANNEL_CONVERSION_RATE_START
});
export const fetchSubchannelConversionRateSuccess = (data: SubchannelConversionResponse) => ({
  type: FETCH_SUBCHANNEL_CONVERSION_RATE_SUCCESS,
  payload: data
});
export const fetchSubchannelConversionRateFailure = (error: string) => ({
  type: FETCH_SUBCHANNEL_CONVERSION_RATE_FAILURE,
  payload: error
});

interface DashboardState {
  overallPerformance: OverallPerformance | null;
  lobPerformance: LOBPerformance[];
  loading: boolean;
  error: string | null;
  channelPerformanceBreakdown: ChannelPerformanceBreakdownResponse | null;
  channelPerformanceBreakdownLoading: boolean;
  channelPerformanceBreakdownError: string | null;
  selectedRegion: string | null;
  selectedProduct: string | null;
  selectedStatus: string | null;
  selectedChannel: string | null;
  selectedSubChannel: string | null;
  parentChannel: string | null;
  showMatrix: boolean;
  showStatusMatrix: boolean;
  showChannelStatusMatrix: boolean;
  showSubChannelStatusMatrix: boolean;
  showPerformanceMatrix: boolean;
  selectedMatrixType: 'product' | 'channel';
  selectedMatrixItem: string;
  subchannelPerformanceBreakdown: any | null;
  subchannelPerformanceBreakdownLoading: boolean;
  subchannelPerformanceBreakdownError: string | null;
  productPerformanceBreakdown: any | null;
  productPerformanceBreakdownLoading: boolean;
  productPerformanceBreakdownError: string | null;
  // New state for distribution data
  productChannelDistribution: ProductChannelResponse | null;
  productChannelDistributionLoading: boolean;
  productChannelDistributionError: string | null;
  channelProductDistribution: ChannelProductResponse | null;
  channelProductDistributionLoading: boolean;
  channelProductDistributionError: string | null;
  // New state for product-status and status-product distribution
  productStatusDistribution: ProductStatusResponse | null;
  productStatusDistributionLoading: boolean;
  productStatusDistributionError: string | null;
  statusProductDistribution: ProductStatusResponse | null;
  statusProductDistributionLoading: boolean;
  statusProductDistributionError: string | null;
  // New state for channel-status distribution
  channelStatusDistribution: ChannelStatusResponse | null;
  channelStatusDistributionLoading: boolean;
  channelStatusDistributionError: string | null;
  // New state for subchannel-status distribution
  subchannelStatusDistribution: SubchannelStatusResponse | null;
  subchannelStatusDistributionLoading: boolean;
  subchannelStatusDistributionError: string | null;
  // New state for conversion rate data
  productConversionRate: ProductConversionResponse | null;
  productConversionRateLoading: boolean;
  productConversionRateError: string | null;
  channelConversionRate: ChannelConversionResponse | null;
  channelConversionRateLoading: boolean;
  channelConversionRateError: string | null;
  subchannelConversionRate: SubchannelConversionResponse | null;
  subchannelConversionRateLoading: boolean;
  subchannelConversionRateError: string | null;
}

const initialState: DashboardState = {
  overallPerformance: null,
  lobPerformance: [],
  loading: false,
  error: null,
  channelPerformanceBreakdown: null,
  channelPerformanceBreakdownLoading: false,
  channelPerformanceBreakdownError: null,
  selectedRegion: null,
  selectedProduct: null,
  selectedStatus: null,
  selectedChannel: null,
  selectedSubChannel: null,
  parentChannel: null,
  showMatrix: false,
  showStatusMatrix: false,
  showChannelStatusMatrix: false,
  showSubChannelStatusMatrix: false,
  showPerformanceMatrix: false,
  selectedMatrixType: 'product',
  selectedMatrixItem: '',
  subchannelPerformanceBreakdown: null,
  subchannelPerformanceBreakdownLoading: false,
  subchannelPerformanceBreakdownError: null,
  productPerformanceBreakdown: null,
  productPerformanceBreakdownLoading: false,
  productPerformanceBreakdownError: null,
  // Initialize distribution data state
  productChannelDistribution: null,
  productChannelDistributionLoading: false,
  productChannelDistributionError: null,
  channelProductDistribution: null,
  channelProductDistributionLoading: false,
  channelProductDistributionError: null,
  // Initialize product-status distribution state
  productStatusDistribution: null,
  productStatusDistributionLoading: false,
  productStatusDistributionError: null,
  statusProductDistribution: null,
  statusProductDistributionLoading: false,
  statusProductDistributionError: null,
  // Initialize channel-status distribution state
  channelStatusDistribution: null,
  channelStatusDistributionLoading: false,
  channelStatusDistributionError: null,
  // Initialize subchannel-status distribution state
  subchannelStatusDistribution: null,
  subchannelStatusDistributionLoading: false,
  subchannelStatusDistributionError: null,
  // Initialize conversion rate data state
  productConversionRate: null,
  productConversionRateLoading: false,
  productConversionRateError: null,
  channelConversionRate: null,
  channelConversionRateLoading: false,
  channelConversionRateError: null,
  subchannelConversionRate: null,
  subchannelConversionRateLoading: false,
  subchannelConversionRateError: null
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setOverallPerformance: (state, action: PayloadAction<OverallPerformance>) => {
      state.overallPerformance = action.payload;
    },
    setLOBPerformance: (state, action: PayloadAction<LOBPerformance[]>) => {
      state.lobPerformance = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setChannelPerformanceBreakdown: (state, action: PayloadAction<ChannelPerformanceBreakdownResponse | null>) => {
      state.channelPerformanceBreakdown = action.payload;
    },
    setChannelPerformanceBreakdownLoading: (state, action: PayloadAction<boolean>) => {
      state.channelPerformanceBreakdownLoading = action.payload;
    },
    setChannelPerformanceBreakdownError: (state, action: PayloadAction<string | null>) => {
      state.channelPerformanceBreakdownError = action.payload;
    },
    setSelectedRegion: (state, action: PayloadAction<string | null>) => {
      state.selectedRegion = action.payload;
    },
    setSelectedProduct: (state, action: PayloadAction<string | null>) => {
      state.selectedProduct = action.payload;
    },
    setSelectedStatus: (state, action: PayloadAction<string | null>) => {
      state.selectedStatus = action.payload;
    },
    setSelectedChannel: (state, action: PayloadAction<string | null>) => {
      state.selectedChannel = action.payload;
    },
    setSelectedSubChannel: (state, action: PayloadAction<string | null>) => {
      state.selectedSubChannel = action.payload;
    },
    setParentChannel: (state, action: PayloadAction<string | null>) => {
      state.parentChannel = action.payload;
    },
    setShowMatrix: (state, action: PayloadAction<boolean>) => {
      state.showMatrix = action.payload;
    },
    setShowStatusMatrix: (state, action: PayloadAction<boolean>) => {
      state.showStatusMatrix = action.payload;
    },
    setShowChannelStatusMatrix: (state, action: PayloadAction<boolean>) => {
      state.showChannelStatusMatrix = action.payload;
    },
    setShowSubChannelStatusMatrix: (state, action: PayloadAction<boolean>) => {
      state.showSubChannelStatusMatrix = action.payload;
    },
    setShowPerformanceMatrix: (state, action: PayloadAction<boolean>) => {
      state.showPerformanceMatrix = action.payload;
    },
    setSelectedMatrixType: (state, action: PayloadAction<'product' | 'channel'>) => {
      state.selectedMatrixType = action.payload;
    },
    setSelectedMatrixItem: (state, action: PayloadAction<string>) => {
      state.selectedMatrixItem = action.payload;
    },
    resetMatrixStates: (state) => {
      state.showMatrix = false;
      state.showStatusMatrix = false;
      state.showChannelStatusMatrix = false;
      state.showSubChannelStatusMatrix = false;
      state.showPerformanceMatrix = false;
      state.selectedProduct = null;
      state.selectedStatus = null;
      state.selectedChannel = null;
      state.selectedSubChannel = null;
      state.parentChannel = null;
    },
    setSubchannelPerformanceBreakdown: (state, action: PayloadAction<any | null>) => {
      state.subchannelPerformanceBreakdown = action.payload;
    },
    setSubchannelPerformanceBreakdownLoading: (state, action: PayloadAction<boolean>) => {
      state.subchannelPerformanceBreakdownLoading = action.payload;
    },
    setSubchannelPerformanceBreakdownError: (state, action: PayloadAction<string | null>) => {
      state.subchannelPerformanceBreakdownError = action.payload;
    },
    setProductPerformanceBreakdown: (state, action: PayloadAction<any | null>) => {
      state.productPerformanceBreakdown = action.payload;
    },
    setProductPerformanceBreakdownLoading: (state, action: PayloadAction<boolean>) => {
      state.productPerformanceBreakdownLoading = action.payload;
    },
    setProductPerformanceBreakdownError: (state, action: PayloadAction<string | null>) => {
      state.productPerformanceBreakdownError = action.payload;
    },
    // New reducers for distribution data
    setProductChannelDistribution: (state, action: PayloadAction<ProductChannelResponse | null>) => {
      state.productChannelDistribution = action.payload;
    },
    setProductChannelDistributionLoading: (state, action: PayloadAction<boolean>) => {
      state.productChannelDistributionLoading = action.payload;
    },
    setProductChannelDistributionError: (state, action: PayloadAction<string | null>) => {
      state.productChannelDistributionError = action.payload;
    },
    setChannelProductDistribution: (state, action: PayloadAction<ChannelProductResponse | null>) => {
      state.channelProductDistribution = action.payload;
    },
    setChannelProductDistributionLoading: (state, action: PayloadAction<boolean>) => {
      state.channelProductDistributionLoading = action.payload;
    },
    setChannelProductDistributionError: (state, action: PayloadAction<string | null>) => {
      state.channelProductDistributionError = action.payload;
    },
    // New reducers for product-status and status-product distribution
    setProductStatusDistribution: (state, action: PayloadAction<ProductStatusResponse | null>) => {
      state.productStatusDistribution = action.payload;
    },
    setProductStatusDistributionLoading: (state, action: PayloadAction<boolean>) => {
      state.productStatusDistributionLoading = action.payload;
    },
    setProductStatusDistributionError: (state, action: PayloadAction<string | null>) => {
      state.productStatusDistributionError = action.payload;
    },
    setStatusProductDistribution: (state, action: PayloadAction<ProductStatusResponse | null>) => {
      state.statusProductDistribution = action.payload;
    },
    setStatusProductDistributionLoading: (state, action: PayloadAction<boolean>) => {
      state.statusProductDistributionLoading = action.payload;
    },
    setStatusProductDistributionError: (state, action: PayloadAction<string | null>) => {
      state.statusProductDistributionError = action.payload;
    },
    // New reducers for channel-status distribution
    setChannelStatusDistribution: (state, action: PayloadAction<ChannelStatusResponse | null>) => {
      state.channelStatusDistribution = action.payload;
    },
    setChannelStatusDistributionLoading: (state, action: PayloadAction<boolean>) => {
      state.channelStatusDistributionLoading = action.payload;
    },
    setChannelStatusDistributionError: (state, action: PayloadAction<string | null>) => {
      state.channelStatusDistributionError = action.payload;
    },
    // New reducers for subchannel-status distribution
    setSubchannelStatusDistribution: (state, action: PayloadAction<SubchannelStatusResponse | null>) => {
      state.subchannelStatusDistribution = action.payload;
    },
    setSubchannelStatusDistributionLoading: (state, action: PayloadAction<boolean>) => {
      state.subchannelStatusDistributionLoading = action.payload;
    },
    setSubchannelStatusDistributionError: (state, action: PayloadAction<string | null>) => {
      state.subchannelStatusDistributionError = action.payload;
    },
    // New reducers for conversion rate data
    setProductConversionRate: (state, action: PayloadAction<ProductConversionResponse | null>) => {
      state.productConversionRate = action.payload;
    },
    setProductConversionRateLoading: (state, action: PayloadAction<boolean>) => {
      state.productConversionRateLoading = action.payload;
    },
    setProductConversionRateError: (state, action: PayloadAction<string | null>) => {
      state.productConversionRateError = action.payload;
    },
    setChannelConversionRate: (state, action: PayloadAction<ChannelConversionResponse | null>) => {
      state.channelConversionRate = action.payload;
    },
    setChannelConversionRateLoading: (state, action: PayloadAction<boolean>) => {
      state.channelConversionRateLoading = action.payload;
    },
    setChannelConversionRateError: (state, action: PayloadAction<string | null>) => {
      state.channelConversionRateError = action.payload;
    },
    setSubchannelConversionRate: (state, action: PayloadAction<SubchannelConversionResponse | null>) => {
      state.subchannelConversionRate = action.payload;
    },
    setSubchannelConversionRateLoading: (state, action: PayloadAction<boolean>) => {
      state.subchannelConversionRateLoading = action.payload;
    },
    setSubchannelConversionRateError: (state, action: PayloadAction<string | null>) => {
      state.subchannelConversionRateError = action.payload;
    },
    [FETCH_PRODUCT_CONVERSION_RATE_SUCCESS]: (state, action: PayloadAction<ProductConversionResponse>) => {
      return {
        ...state,
        productConversionRate: action.payload,
        productConversionRateLoading: false,
        productConversionRateError: null
      };
    },
    [FETCH_CHANNEL_CONVERSION_RATE_SUCCESS]: (state, action: PayloadAction<ChannelConversionResponse>) => {
      return {
        ...state,
        channelConversionRate: action.payload,
        channelConversionRateLoading: false,
        channelConversionRateError: null
      };
    },
    [FETCH_SUBCHANNEL_CONVERSION_RATE_SUCCESS]: (state, action: PayloadAction<SubchannelConversionResponse>) => {
      return {
        ...state,
        subchannelConversionRate: action.payload,
        subchannelConversionRateLoading: false,
        subchannelConversionRateError: null
      };
    },
  },
});

export const {
  setOverallPerformance,
  setLOBPerformance,
  setLoading,
  setError,
  setChannelPerformanceBreakdown,
  setChannelPerformanceBreakdownLoading,
  setChannelPerformanceBreakdownError,
  setSelectedRegion,
  setSelectedProduct,
  setSelectedStatus,
  setSelectedChannel,
  setSelectedSubChannel,
  setParentChannel,
  setShowMatrix,
  setShowStatusMatrix,
  setShowChannelStatusMatrix,
  setShowSubChannelStatusMatrix,
  setShowPerformanceMatrix,
  setSelectedMatrixType,
  setSelectedMatrixItem,
  resetMatrixStates,
  setSubchannelPerformanceBreakdown,
  setSubchannelPerformanceBreakdownLoading,
  setSubchannelPerformanceBreakdownError,
  setProductPerformanceBreakdown,
  setProductPerformanceBreakdownLoading,
  setProductPerformanceBreakdownError,
  // Export new actions
  setProductChannelDistribution,
  setProductChannelDistributionLoading,
  setProductChannelDistributionError,
  setChannelProductDistribution,
  setChannelProductDistributionLoading,
  setChannelProductDistributionError,
  // Export new actions for product-status and status-product distribution
  setProductStatusDistribution,
  setProductStatusDistributionLoading,
  setProductStatusDistributionError,
  setStatusProductDistribution,
  setStatusProductDistributionLoading,
  setStatusProductDistributionError,
  // Export new actions for channel-status distribution
  setChannelStatusDistribution,
  setChannelStatusDistributionLoading,
  setChannelStatusDistributionError,
  // Export new actions for subchannel-status distribution
  setSubchannelStatusDistribution,
  setSubchannelStatusDistributionLoading,
  setSubchannelStatusDistributionError,
  // Export new actions for conversion rate data
  setProductConversionRate,
  setProductConversionRateLoading,
  setProductConversionRateError,
  setChannelConversionRate,
  setChannelConversionRateLoading,
  setChannelConversionRateError,
  setSubchannelConversionRate,
  setSubchannelConversionRateLoading,
  setSubchannelConversionRateError,
} = dashboardSlice.actions;

export default dashboardSlice.reducer; 